import React from "react";
import HeroVideo1 from "../components/HeroVideo1";
import ImageText2 from "../components/Imagetext2";
import RichText from "../components/RichText";

import video from "../assets/videos/vmax1.mp4";
import imageurl1 from "../assets/images/vmax.png";
import video2 from "../assets/videos/service2.mp4";

function Vmax() {
  const text1 = (
    <>
      <p className="text-white text-lg">
        V-Max is een snelheidsbegrenzer die in veel voertuigen is
        geprogrammeerd. In de meeste gevallen zijn deze begrensd op een aantal
        km/ u, dit verschilt per type voertuig. Hierdoor kunt uniet altijd de
        topsnelheid uit uw auto halen. Het is een optie om de begrenzer
        permanent te verwijderen. Deze service wordt ook vaak afgenomen in
        combinatie met een chiptuning.
      </p>
      <br />
      <p className="text-white text-lg">
        Deze service is vaak ook aantrekkelijk voor bedrijfswagens met een
        maximumsnelheid tot 100 km/u.
      </p>
      <br />
      <p className="text-white text-lg font-semibold">
        Procedure verwijderen v-max
      </p>
      <p className="text-white text-lg">
        De auto wordt uitgelezen zoals bij elke afname van onze service,
        vervolgens stellen wij een diagnose van de auto en door middel van
        softwarematige aanpassingen wordt de snelheidsbegrenzer permanent
        verwijderd. Hierbij zijn geen fysieke aanpassingen vereist waarbij deze
        fijn te combineren is met een chiptuning stage 1.
      </p>
    </>
  );

  return (
    <div>
      <HeroVideo1 videoSource={video} heading="V-MAX" />
      <RichText heading="Snelheidsbegrenzer uitschrijven/ verwijderen" />
      <ImageText2
        text={text1}
        imageUrl={imageurl1}
        leftColor="#000"
        rightColor="#000"
        textColor="white"
        borderColor="#BD0E0E"
        borderWidth="2px"
      />
      <HeroVideo1
        videoSource={video2}
        heading="Benieuwd welke services er beschikbaar zijn voor uw auto?Kies uw auto voor de beschikbare services of klik hier om contact met ons op te nemen!"
        buttontext="Zoek uw optimalisatie"
        buttonlink="/contact-us"
      />
    </div>
  );
}

export default Vmax;
